import { zodTransformFirestoreTimestampToDate } from "../utils/zodUtils.mjs";
import { zodFlavorId } from "./ids.mjs";
import { PiiCategory, meta } from "./meta.mjs";
import { z as z$1 } from "zod";

// src/models/customerNotificationDeliveryLog.ts
/**
* UTC month key used as Firestore document id: `YYYY_MM` (e.g. `2026_05`).
*/
function monthDocIdFromDate(d) {
	return monthDocIdFromYearMonth(d.getUTCFullYear(), d.getUTCMonth() + 1);
}
function monthDocIdFromYearMonth(year, month1to12) {
	return `${year}_${String(month1to12).padStart(2, "0")}`;
}
const customerNotificationDeliveryLogEventSchema = z$1.object({
	eventId: z$1.string(),
	text: meta(z$1.string().optional(), { pii: { category: "freeText" } }),
	type: z$1.string().optional(),
	/**
	* Required on all events: send-time status (e.g. `sent_to_customer_io`) or Customer.io
	* Reporting Webhook `metric` for lifecycle rows (e.g. `delivered`, `bounced`).
	*/
	deliveryStatus: z$1.string(),
	/**
	* Required on all events: Customer.io `track` `messageId` (send) or reporting webhook
	* `trigger_event_id` (lifecycle) for correlating rows in the delivery log UI.
	*/
	triggerMessageId: z$1.string(),
	/** Customer.io `track` properties (or FCM payload fields) for admin diagnostics. */
	metadata: meta(z$1.record(z$1.string(), z$1.unknown()).optional(), {
		bqType: "stringified_map",
		pii: { category: "freeText" }
	}),
	timestamp: z$1.any().transform(zodTransformFirestoreTimestampToDate).pipe(z$1.date())
});
const customerNotificationDeliveryLogMonthDocSchema = z$1.object({
	id: zodFlavorId(),
	customerId: zodFlavorId(),
	monthDocId: zodFlavorId().optional(),
	events: z$1.array(customerNotificationDeliveryLogEventSchema)
}).refine((d) => d.monthDocId === void 0 || d.monthDocId === d.id, {
	message: "monthDocId must match document id when present",
	path: ["monthDocId"]
});

export { customerNotificationDeliveryLogEventSchema, customerNotificationDeliveryLogMonthDocSchema, monthDocIdFromDate, monthDocIdFromYearMonth };
//# sourceMappingURL=customerNotificationDeliveryLog.mjs.map